"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireDefault(require("react"));
var _apiPayments = _interopRequireDefault(require("../../../../api/api-payments"));
var _form = require("../forms/form");
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var TaxIDForm = /*#__PURE__*/function (_React$Component) {
  _inherits(TaxIDForm, _React$Component);
  function TaxIDForm(props) {
    var _this;
    _classCallCheck(this, TaxIDForm);
    _this = _callSuper(this, TaxIDForm, [props]);
    _this.state = {
      errorMessage: ''
    };
    _this.finalCallback = _this.finalCallback.bind(_assertThisInitialized(_this));
    _this.submitForm = _this.submitForm.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(TaxIDForm, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;
      _apiPayments.default.getRecipientData(PSSessions.Cookies('PSUser'), PSSessions.Cookies('PSAccess'), function (res) {
        if (200 === res.statusCode) {
          _this2.setState({
            recipientObj: res
          });
        }
      });
    }
  }, {
    key: "finalCallback",
    value: function finalCallback(hasError) {
      if (!hasError) {
        this.props.callback();
      }
    }
  }, {
    key: "submitForm",
    value: function submitForm(form, callback) {
      var _this3 = this;
      var payload = {
        tax_id: $('#tax-id').val()
      };
      _apiPayments.default.updateBank(PSSessions.Cookies('PSUser'), PSSessions.Cookies('PSAccess'), payload, function (response) {
        if (200 !== response.statusCode) {
          var errorMessage = response.error ? response.error.message : _this3.props.intl.formatMessage({
            id: 'shared_components.tax_id_form.error_message',
            defaultMessage: 'An unexpected error occured. Please try again in a few minutes.'
          });
          _this3.setState({
            errorMessage: errorMessage
          });
          callback(true);
        } else {
          callback();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var label;
      var placeholder;
      var recipientObj = this.state.recipientObj;
      if (!recipientObj) {
        return /*#__PURE__*/_react.default.createElement("div", null);
      }
      var accountDetails = recipientObj.active_account;
      var account = accountDetails.last4;
      var institution = accountDetails.bank_name;
      var subText = "".concat(institution, " - ").concat(account);
      if ('individual' === recipientObj.type) {
        label = this.props.intl.formatMessage({
          id: 'shared_components.tax_id_form.security_number_label',
          defaultMessage: 'Social Security Number'
        });
        placeholder = 'XXX-XX-XXXX';
      } else {
        label = this.props.intl.formatMessage({
          id: 'shared_components.tax_id_form.identification_number_label',
          defaultMessage: 'Employer Identification Number (EIN)'
        });
        placeholder = 'XX-XXXXXXX';
      }
      var formInputs = [{
        elementID: 'tax-id',
        inputFieldName: 'tax_id',
        optional: false,
        labelSize: 'col-xs-12',
        helperText: this.props.intl.formatMessage({
          id: 'shared_components.tax_id_form.not_store_banking_data',
          defaultMessage: 'We do not store your banking data. We pass it securely to our payments partner.'
        }),
        label: label,
        placeholder: placeholder
      }];
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          marginLeft: 45,
          marginRight: 45
        }
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "heading text-center"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.tax_id_form.add_tax_id",
        defaultMessage: "Add Your Tax ID"
      })), /*#__PURE__*/_react.default.createElement("p", {
        className: "form-standard"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.tax_id_form.add_tax_id_description",
        defaultMessage: "Please enter your tax ID for your account below. This information is for identity verification required for payouts and tax compliance."
      })), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: 83
        },
        className: "form-standard bg-gray-100 sborder-gray-400"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "label text-center",
        style: {
          marginBottom: 7,
          marginTop: 22
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.tax_id_form.payout_account",
        defaultMessage: "Your payout account"
      })), /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement("p", {
        className: "text-center"
      }, subText))), /*#__PURE__*/_react.default.createElement(_form.FormBuilder, {
        formname: "taxID",
        id: "tax-form",
        formStyle: "standard",
        formInputs: formInputs,
        errorText: this.state.errorMessage,
        submitAction: this.submitForm,
        submitCallback: this.finalCallback,
        buttonText: this.props.intl.formatMessage({
          id: 'shared_components.tax_id_form.button_update',
          defaultMessage: 'Update'
        })
      }));
    }
  }]);
  return TaxIDForm;
}(_react.default.Component);
exports.TaxIDForm = (0, _reactIntl.injectIntl)(TaxIDForm);